import commonFun from "@/utils/commonFun";

export default [
    {
        path:'/ssr-manage',
        name: 'ssr-manage',
        component:() => import ('@/components/page/ssr-manage/ssr-manage-search'),
        meta: { title:'nav.ssrManage',type:"ssr" },
    },
    {
        path:'/ssr-manage-add',
        component:() => import ('@/components/page/ssr-manage/ssr-manage-add'),
        name:'ssr-manage-add',
        meta: { title:'common.add',type:"ssr" },
    },
    {
        path:'/ssr-manage-cqs',
        component:() => import ('@/components/page/ssr-manage/ssr-manage-cqs'),
        name:'ssr-manage-detailCqs',
        meta: { title:'ssrManage.ssrCqs',type:"ssr" },
    },
    {
        path:'/ssr-detail-ss',
        component:() => import ('@/components/page/ssr-manage/ssr-detail-ss'),
        name:'ssr-manage-detailSs',
        meta: { title:'common.details',type:"ssr" },
    },
    {
        path:'/ssr-detail-supp',
        component:() => import ('@/components/page/ssr-manage/ssr-detail-supp'),
        name:'ssr-manage-detailSupp',
        meta: { title:'common.details',type:"ssr" },
    },
    {
        path:'/ssr-detail-load',
        component:() => import ('@/components/page/ssr-manage/ssr-detail-load'),
        name:'ssr-manage-detailSupp',
        meta: { title:'common.details',type:"ssr" },
    },
    {
        name: 'ssr-manage-audit',
        path: '/ssr-manage-detailAudit',
        meta: {title: 'common.details',type:"ssr"},
        redirect: to => {
            const {hash, params, query} = to;
            if (commonFun.isSupplier()) {
                return {path: "/ssr-detail-supp", query: {id: query.id}};
            } else {
                return {path: "/ssr-detail-ss", query: {id: query.id}};
            }
        }
    }
]
